<div>
	<div class="card">
		<div class="card-header datatable-search" style="padding-top: 15px; padding-bottom: 15px; display: inline;">
			<h2>Zesty's Teams integration guide</h2><br>
		</div>
	</div>

	<br><h4>Step 1:</h4><br>
	<img src="https://s3-eu-west-1.amazonaws.com/static.cloudvisor.io/assets/TeamsIntegration/TeamsIntegration-1.png"
			 alt="Step 1"><br>
	<br><h4>Step 2:</h4><br>
	<img src="https://s3-eu-west-1.amazonaws.com/static.cloudvisor.io/assets/TeamsIntegration/TeamsIntegration-2.png"
			 alt="Step 2"><br>
	<br><h4>Step 3:</h4><br>
	<img src="https://s3-eu-west-1.amazonaws.com/static.cloudvisor.io/assets/TeamsIntegration/TeamsIntegration-3.png"
			 alt="Step 3"><br>
	<br><h4>Step 4:</h4><br>
	<img src="https://s3-eu-west-1.amazonaws.com/static.cloudvisor.io/assets/TeamsIntegration/TeamsIntegration-4.png"
			 alt="Step 4"><br>
	<br><h4>Step 5:</h4><br>
	<img src="https://s3-eu-west-1.amazonaws.com/static.cloudvisor.io/assets/TeamsIntegration/TeamsIntegration-5.png"
			 alt="Step 5"><br>
	<br><h4>Step 6:</h4><br>
	<img src="https://s3-eu-west-1.amazonaws.com/static.cloudvisor.io/assets/TeamsIntegration/TeamsIntegration-6.png"
			 alt="Step 6"><br>
</div>
